export default __webpack_public_path__ + "static/media/login_logo.3eda833f.png";